const signalR = require("@microsoft/signalr");
import global from '@/global'
import {
    Message,
    MessageBox
} from 'element-ui';


export default function () {

    let connection = new signalR.HubConnectionBuilder()
        .withUrl(global.host + '/notifyHub', {
            accessTokenFactory: () => {
                return global.getToken()
            }
        })
        .build();

    connection.start().then(() => {

    }).catch((err) => {
        Message.error({
            message: '实时通讯连接错误'
        })
    });
    //强制下线
    connection.on("offline", data => {
        sessionStorage.clear();
        MessageBox({
            title: '系统提示',
            message: '您已被强制下线',
            callback: () => {
                window.location.reload();
            }
        })
    });
    //接收实时消息
    connection.on('SendMsg', data => {
        MessageBox({
            title: '实时消息',
            message: data
        })
    })
}